const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;

/**
 * Data stores
 */
let _resourceListData = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
const WorkoutsStore = assign({}, ModelStore, {
    getResourceListData: function () {
        return _resourceListData;
    }
});

/**
 * Event Listeners
 */
WorkoutsStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'WORKOUTS_LISTED':
            _resourceListData = action.data;

            WorkoutsStore.emitChange();
            break;
    }
});

module.exports = WorkoutsStore;
